export default function detailevent (event = {}, action) { 
    switch (action.type) {
    case "MODIFY_WORD":
        return {
            ...event,
            value: action.response.data.body
        }
    default: 
        return event 
    }
}
